import { render, staticRenderFns } from "./Grid.vue?vue&type=template&id=13a3bcb3&scoped=true&"
import script from "./Grid.vue?vue&type=script&lang=ts&"
export * from "./Grid.vue?vue&type=script&lang=ts&"
import style0 from "./Grid.vue?vue&type=style&index=0&id=13a3bcb3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a3bcb3",
  null
  
)

export default component.exports